<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less">
html,
body {
  height: 100%;
  position: relative;
  background-color: #ffffff;
  min-height: 100%;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  min-width: 1200px;
  height: 100%;
  position: relative;
}
</style>
